import { NetworkServer } from '~/modules/remote-mic/network/server/network-server';

const server = new NetworkServer();

export default server;
